(function () {
  'use strict';
  if (window.FsPriceCheckAnalytics) return;
  const verifiedStates = new Set(['current', 'sale', 'privateApplied', 'verified']);
  const failureReasons = new Set(['cancelled', 'network', 'timeout', 'http', 'invalid-json', 'offer_not_applied', 'incomplete', 'review']);
  const count = value => Number.isSafeInteger(value) && value >= 0 ? value : 0;
  const amount = value => count(value) / 100;
  function cartData(cart) {
    const items = Array.isArray(cart?.items) ? cart.items : [];
    const currency = String(cart?.currency || '').toUpperCase();
    return {
      line_item_count: items.length,
      unit_count: items.reduce((sum, item) => sum + count(item.quantity), 0),
      ...(/^[A-Z]{3}$/.test(currency) ? { currency } : {})
    };
  }
  function publish(name, data) {
    try {
      const shopify = window.Shopify;
      if (typeof shopify?.customerPrivacy?.analyticsProcessingAllowed === 'function' &&
          shopify.customerPrivacy.analyticsProcessingAllowed() !== true) return false;
      if (typeof shopify?.analytics?.publish !== 'function') return false;
      // Do not wait for a pixel, or let rejected analytics promises affect the cart.
      const pending = shopify.analytics.publish(name, data);
      if (typeof pending?.catch === 'function') pending.catch(() => {});
      return true;
    } catch (_) { return false; }
  }
  function begin(cart) {
    const startedAt = performance.now();
    const checkId = typeof window.crypto?.randomUUID === 'function' ? window.crypto.randomUUID() :
      Date.now().toString(36) + '-' + Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2);
    const base = { schema_version: 1, check_id: checkId };
    let currentCart = cart, ended = false;
    const published = publish('neurowave:price_check_started', {
      ...base, ...cartData(cart), duration_ms: 0, outcome: 'started'
    });
    function finish(event, details) {
      if (ended) return;
      ended = true;
      if (!published) return;
      publish(event, {
        ...base, ...cartData(currentCart),
        duration_ms: Math.max(0, Math.round(performance.now() - startedAt)), ...details
      });
    }
    return {
      update(cart) { currentCart = cart; },
      complete(cart, reviewed, issue) {
        currentCart = cart;
        const pairs = Array.isArray(reviewed) ? reviewed : [];
        const verified = pairs.filter(([, result]) => verifiedStates.has(result?.state));
        const matches = pairs.filter(([, result]) => result?.state === 'privateApplied');
        const summary = {
          verified_item_count: verified.length,
          matched_item_count: matches.length,
          matched_savings: amount(matches.reduce((sum, [, result]) => sum + count(result.savings), 0)),
          sale_savings: amount(pairs.reduce((sum, [, result]) => sum + (result?.state === 'sale' ? count(result.savings) : 0), 0))
        };
        if (issue || !pairs.length || verified.length !== pairs.length) {
          finish('neurowave:price_check_failed', { ...summary, outcome: 'failed', failure_reason: issue ? 'offer_not_applied' : 'incomplete' });
          return;
        }
        const keys = new Set(verified.map(([key]) => key));
        const ids = (Array.isArray(cart?.items) ? cart.items : []).filter(item => keys.has(item.key))
          .map(item => String(item.variant_id || '')).filter(id => /^\d{1,20}$/.test(id));
        finish('neurowave:price_check_completed', {
          ...summary, verified_variant_ids: [...new Set(ids)], outcome: matches.length ? 'matched' : 'verified'
        });
      },
      fail(reason) {
        finish('neurowave:price_check_failed', {
          outcome: 'failed', failure_reason: failureReasons.has(reason) ? reason : 'review'
        });
      }
    };
  }
  window.FsPriceCheckAnalytics = { begin };
})();
